export default __webpack_public_path__ + "static/media/repoIcon.45422ad0.png";